import { masterBreakPoint } from "themes/default/breakpoints"
import { theme } from "themes/default/theme"

export const styles = {
  wrapper: {},
  mediaContainer: {
    flexWrap: "nowrap",
    borderTop: `1px solid rgba(0,0,0,.1)`,
    pt: 1.25,
  },
  playButton: {
    width: 24,
    height: 24,
    // top: -4,
    padding: 0,
    background: "#e5e5e5",
    "&:hover": {
      background: "#00000050",
    },
  },
  playIcon: {
    color: "#808080ff",
    fontSize: 20,
    "&:hover": {
      color: "#fff",
    },
  },
  redoIButton: {
    // width: 24,
    // height: 24,
    // top: -4,
    padding: 0,
    pl: 1,
  },
  redoIcon: {
    color: "#808080ff",
    fontSize: 12,
  },
  iconActive: {
    color: theme.palette.primary.main,
  },
  sliderContainer: {
    width: `calc(100% - 58px)`,
    mx: 0.625,
    borderRadius: 2.5,
    overflow: "hidden",
  },
  slider: {
    background: `rgba(0,0,0,.1)`,
    borderRadius: 2.5,
    height: 10,
    "& .MuiLinearProgress-bar": {
      background:
        "linear-gradient(105.2deg, rgb(253, 176, 71) 11.2%, rgb(255, 78, 78) 117.9%)",
      borderRadius: 2.5,
      height: 10,
      transitionDuration: "0.3s",
    },
  },
  buttonsContainer: {
    position: "absolute",
    bottom: -32,
    right: 0,
    [masterBreakPoint]: {
      bottom: -30,
    },
  },
  seeLaterBtn: {
    position: "absolute",
    left: 0,
    bottom: -32,
    padding: "1.5px 7px",
    fontSize: 12,
    [masterBreakPoint]: {
      bottom: -30,
      padding: "3px 7px",
    },
  },
  seeLaterBtnText: {
    fontSize: 12,
    paddingTop: "1.5px",
    paddingBottom: "1.5px",
    [masterBreakPoint]: {
      padding: 0,
    },
  },
}
